import type { CSSProperties } from '@main/core-ui';
import { FlexColumnCenterVertical, FlexRowCenterVertical } from '@main/core-ui';
import React from 'react';
import { useTheme } from 'styled-components';

import {
  StyledCardInfoWrapper,
  StyledCardTitleContainer,
  StyledCardTitleWrapper,
  StyledCardWrapper,
} from './wrappers';

export interface CardProps {
  /** title of the item */
  title?: string;
  /** description of the item */
  description?: string | JSX.Element;
  /** children contents */
  children?: React.ReactNode;
  /**
   * Additional react components that will be displayed
   * inline and right aligned to the title
   */
  titleExtras?: React.ReactNode;
  /** style object */
  style?: CSSProperties;
  /** title description */
  titleDescription?: string;
  /** whether the card is disabled */
  disabled?: boolean;
}
/**
 * Base component for card
 */
export const Card: React.FC<React.PropsWithChildren<CardProps>> = ({
  title,
  children,
  description,
  titleDescription,
  titleExtras,
  style,
  disabled = false,
}) => {
  const theme = useTheme();
  return (
    <StyledCardWrapper style={style} disabled={disabled}>
      {(title || titleExtras || titleDescription) && (
        <StyledCardTitleContainer>
          <FlexColumnCenterVertical>
            {title && <StyledCardTitleWrapper>{title}</StyledCardTitleWrapper>}
            {titleDescription && (
              <p style={{ margin: 0, color: theme.colors.textLightOnBg }}>
                {titleDescription}
              </p>
            )}
          </FlexColumnCenterVertical>
          {titleExtras && (
            <FlexRowCenterVertical style={{ flexShrink: 0 }}>
              {titleExtras}
            </FlexRowCenterVertical>
          )}
        </StyledCardTitleContainer>
      )}
      {(description || children) && (
        <StyledCardInfoWrapper>
          {description && <p style={{ margin: 0 }}>{description}</p>}
          {children && children}
        </StyledCardInfoWrapper>
      )}
    </StyledCardWrapper>
  );
};
